module.exports = __webpack_public_path__ + "img/phone.b546e6e8.svg";